import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import ReportAcknowledgement from '../ReportAcknowledgement';
import ReportApproval from '../ReportApproval';
import ReportReview from '../ReportReview';
import CheckoffElement from './CheckoffElement';
import CommentElement from './CommentElement';
import DatetimeElement from './DatetimeElement';
import RatingElement from './RatingElement';
import SignatureElement from './SignatureElement';
import './DynamicReport.scss';
import RatingMultiElement from "./RatingMultiElement";
import RatingSimpleElement from "./RatingSimpleElement";
import RemedialTrainingResponse from "../dynamic-form/RemedialTrainingResponse";
import CallTrackingResponse from "../dynamic-form/CallTrackingResponse";
import ReportApproveThree from "../ReportApproveThree";
import RejectFormForm from "../dynamic-form/RejectFormForm";
import RecallFormForm from "../dynamic-form/RecallFormForm";
import AckResponse from "./AckResponse";
import {Auth} from "../../../../shared/services/aws";
import DailyPatrolLogResponse from "../dynamic-form/DailyPatrolLogResponse";
import LogFieldResponse from "../dynamic-form/LogFieldResponse";
import QuestionFieldResponse from "../dynamic-form/QuestionFieldResponse";
import departmentSettingsSelectors from "../../../store/department-settings/selectors";
import ReportApproveFour from "../ReportApproveFour";
import ReportApproveFive from "../ReportApproveFive";
import PtoRatingMultiElementEdit from "./PtoRatingMultiElementEdit";
import TimeTrackingField from "../dynamic-form/TimeTrackingField";
import PbleField from "../dynamic-form/PbleField";
import trainingPhasesActionCreators from "../../../store/training-phases/action-creators";
import EvaluationRatingResponse from "../dynamic-form/EvaluationRatingResponse";
import EvaluationRatingElement, {EvaluationPanel} from "./EvaluationRatingElement";


const isNotAssignedFtoSubmitter = (phase, report) => {
  let signFlow = report.signFlow[report.type];
  if (phase && phase.fto && report && signFlow.submit && signFlow.submit.roles && signFlow.submit.roles.includes('fto')) {
    return phase.fto.ftoGuid !== report.author.authorGuid;
  } else {
    return false;
  }
};

class DynamicReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      responsesAck: this.props.report.responsesAck || {},
      authToken: ''
    }

  }

  componentDidMount() {
    Auth.currentSession()
      .then(res => {
        this.setState({
          authToken: res.accessToken.jwtToken
        })
      })
  }

  get canAck() {
    return this.props.report.getCanAcknowledge(this.props.userContext.scope)
      && this.props.view.elements.filter(el => el.schema === 'pto-rating-multi' || el.schema === 'evaluation-rating')
        .reduce((canAck, el) => {
          if (el.schema === 'evaluation-rating') {
            return !!this.state.responsesAck[el.id] && this.state.responsesAck[el.id].isValid && canAck
          }
          return !!this.state.responsesAck[el.id] && this.state.responsesAck[el.id].isValid && canAck
        }, true)
  }

  get canSkipAck() {
    return this.props.userContext.hasScope(['ftoc', 'sup'])
      && this.props.report.getCanAcknowledge('oit')
  }

  get canReject() {
    return (this.props.report.getCanAcknowledge(this.props.userContext.scope) && !this.props.userContext.hasScope('oit'))
      || (this.props.report.getIsCompleted() && !this.props.userContext.hasScope('oit') && !this.props.userContext.hasScope('fto'))
      || (
        this.props.report.getIsSubmitted()
        && this.props.userContext.hasScope('ftoc')
        && !this.props.report.getTypeHasApproval()
        && !this.props.report.getTypeHasApproveTwo()
        && !this.props.report.getTypeHasApproveThree()
        && !this.props.report.getTypeHasApproveFour()
        && !this.props.report.getTypeHasApproveFive()
      );
  }

  get rejectionNote() {
    if (!this.props.report) {
      return null
    }
    let rejections = this.props.report.rejections.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return new Date(b.insertedAt) - new Date(a.insertedAt);
    });

    return rejections[0]
  }

  get canRecall() {
    return this.props.report.getIsSubmitted()
      && this.props.report.author
      && this.props.report.author.authorGuid === this.props.userContext.userGuid;
  }

  onUpdateComment(comment, id) {
    clearTimeout(this.autoSaveTimeOut);
    this.setState({
      responsesAck: {
        ...this.state.responsesAck,
        [id]: comment
      }
    }, () => {
      if(this.props.report.getCanAcknowledge(this.props.userContext.scope)) {
        this.autoSaveTimeOut = setTimeout(() => {
          this.props.acknowledgeReportUpdate && this.props.acknowledgeReportUpdate({
            responsesAck: this.state.responsesAck,
            guid: this.props.report.guid
          });
        }, 3000)
      }
    })
  }

  markReportAsNotObserved() {
    let responsesAck = {
      ...this.state.responsesAck
    }
    this.props.view.elements.filter(el =>
      (el.schema === 'pto-rating-multi' && (el.useNotObserved !== undefined ? el.useNotObserved !== false : el.useNoNr !== false)) ||
      (el.schema === 'evaluation-rating' && (el.useNotObserved !== undefined ? el.useNotObserved !== false : el.useNoNr !== false))
    )
      .forEach(el => {
        responsesAck[el.id] = {
          ...(responsesAck[el.id] || {
            comment: "",
            isValid: false,
            notObserved: false,
            notResponsive: false,
            rating: 0,
            timeSpend: null
          }),
          rating: 0,
          notObserved: true,
          isValid: true
        }
      })

    this.setState({responsesAck})
  }

  get hasRatingFields() {
    return this.props.report.getCanAcknowledge(this.props.userContext.scope) && !!this.props.view.elements.find(el => el.schema === 'pto-rating-multi' || el.schema === 'evaluation-rating')
  }

  get isValid() {
    if(this.props.userContext.scope !== 'oit') {
      return true
    }
    return this.props.view.elements
      .reduce((isValid, element) => {
        return isValid && (!element.requireAckResponse || (element.requireAckResponse && this.state.responsesAck[element.id] !== undefined ) )
      }, true)
  }

  render() {
    let props = this.props;
    return (
      <Fragment>
        <div className="text-right download-report">
          <div className="report-header-info">
            {props.phase && <div className="report-info-row">
              <div>Phase:</div>
              {props.phase.header}</div>}
            {!props.phase && props.report.trainingPhaseHeader && <div className="report-info-row">
              <div>Phase:</div>
              {props.report.trainingPhaseHeader}</div>}
            {props.report.oit ? (
              <div className="report-info-row">
                <div>{props.oitShortLabel}:</div>
                {props.report.oit}</div>
            ) : (
              <div className="report-info-row">
                <div>{props.oitShortLabel}:</div>
                {props.report.getFullNameFor('acknowledger')}</div>
            )}
            {!props.report.getIsSubmitterOit() && <div className="report-info-row">
              <div>{props.ftoShortLabel}:</div>
              {props.report.getFullNameFor('author')}</div>}
            {props.report.shift && <div className="report-info-row" style={{textTransform: 'capitalize'}}>
              <div>Shift:</div>
              {props.report.shift}</div>}
          </div>
          <div>
            {this.hasRatingFields &&
              <button onClick={() => this.markReportAsNotObserved()}
                      style={{marginRight: '10px'}}
                      className="button secondary small">
                Mark report as not observed
              </button>}
            <button onClick={() => this.props.onOpenTasks && this.props.onOpenTasks(props.report)}
                    className="button secondary small">
              Tasks
            </button>
            <button onClick={() => this.props.onChangePhase && this.props.onChangePhase(props.report)}
                    className="button secondary small">
              Change phase
            </button>
            <a className="button primary small"
               href={`/api/v1/reports/${props.report.guid}/pdf/${this.state.authToken}`}
               download={`${props.report.getFullNameFor('acknowledger').replace(' ', '_')}.pdf`}>
              <i className="fa fa-download"/>
              <span>Download PDF</span>
            </a>
          </div>
        </div>
        {!props.userContext.hasScope('oit') && !this.props.report.getIsCompleted() && this.rejectionNote && (
          <div className="report-rejections">
            <h4>Rejection note </h4>
            {this.rejectionNote.reason}
          </div>
        )}
        {isNotAssignedFtoSubmitter(props.phase, props.report) && (
          <div className="submitted-by-not-assigned">
            <i className="fa fa-warning"/>
            <span>
            This report is submitted by
            <b> {props.report.author.firstName} </b>
            <b> {props.report.author.lastName} </b>
            but this phase is assigned to
            <b> {props.phase.fto.firstName} </b>
            <b> {props.phase.fto.lastName} </b>
          </span>
          </div>
        )}
        <div className="dynamic-report">
          {props.view.elements.map((element, index) => {
            if (element.type === 'header') {
              return (
                <legend key={index.toString()}
                        style={{
                          whiteSpace: 'pre-line',
                          unicodeBidi: 'embed',
                          maxWidth: '100%',
                          fontSize: '1em',
                          padding: '15px 30px'
                        }}>
                  {element.content}
                </legend>
              );
            }
            switch (element.schema) {
              case 'checkoff':
                return (
                  <AckResponse
                    key={index.toString()}
                    comment={this.state.responsesAck[element.id]}
                    onChangeComment={(comment) => this.onUpdateComment(comment, element.id)}
                    canAck={props.report.getCanAcknowledge(props.userContext.scope)}
                    requireAckResponse={element.requireAckResponse}>
                    <CheckoffElement
                      isChecked={element.isChecked}
                      prompt={element.prompt}
                      checkoffPrompt={element.checkoffPrompt}
                    />
                  </AckResponse>
                );
              case 'comment':
                console.log('this.report.author', props.report.author)
                return (
                  <AckResponse
                    key={index.toString()}
                    comment={this.state.responsesAck[element.id]}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                    onChangeComment={(comment) => this.onUpdateComment(comment, element.id)}
                    canAck={props.report.getCanAcknowledge(props.userContext.scope)}
                    requireAckResponse={element.requireAckResponse}>
                    <CommentElement
                      author={props.report.getFullNameFor('author')}
                      comment={element.comment}
                      prompt={element.prompt}
                    />
                  </AckResponse>
                );
              case 'datetime':
                return (
                  <DatetimeElement
                    key={index.toString()}
                    datetime={element.datetime}
                    prompt={element.prompt}
                  />
                );
              case 'rating':
                return (
                  <AckResponse
                    key={index.toString()}
                    comment={this.state.responsesAck[element.id]}
                    onChangeComment={(comment) => this.onUpdateComment(comment, element.id)}
                    canAck={props.report.getCanAcknowledge(props.userContext.scope)}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                    requireAckResponse={element.requireAckResponse}>
                    <RatingElement
                      prompt={element.prompt}
                      rating={element.rating}
                    />
                  </AckResponse>
                );
              case 'rating-multi':
                return (
                  <AckResponse
                    key={index.toString()}
                    comment={this.state.responsesAck[element.id]}
                    onChangeComment={(comment) => this.onUpdateComment(comment, element.id)}
                    canAck={props.report.getCanAcknowledge(props.userContext.scope)}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                    requireAckResponse={element.requireAckResponse}>
                    <RatingMultiElement
                      ratingPrompt={element.ratingPrompt}
                      notObservedPrompt={element.notObservedPrompt}
                      notResponsivePrompt={element.notResponsivePrompt}
                      defaultComments={element.defaultComments}
                      rating={element.rating}
                      notObserved={element.notObserved}
                      notResponsive={element.notResponsive}
                      timeSpend={element.timeSpend}
                      comment={element.comment}
                      overrideDefaultScores={element.overrideDefaultScores}
                      scoreOverrides={element.scoreOverrides}
                      scale={props.report.settings ? props.report.settings.scale : props.departmentSettings.scale}
                      // useNoNr={element.useNoNr}
                      useNoNr={element.notResponsive || element.notObserved}
                    />
                  </AckResponse>
                );
              case 'pto-rating-multi':
                let responsesForAck = this.state.responsesAck[element.id] || {
                  rating: element.rating,
                  notObserved: element.notObserved,
                  notResponsive: element.notResponsive,
                  comment: element.comment,
                  timeSpend: element.timeSpend
                };

                return props.report.getCanAcknowledge(props.userContext.scope) ?
                  <PtoRatingMultiElementEdit
                    key={index.toString()}
                    ratingPrompt={element.ratingPrompt}
                    notObservedPrompt={element.notObservedPrompt}
                    notResponsivePrompt={element.notResponsivePrompt}
                    defaultComments={element.defaultComments}
                    requiredComments={element.requiredComments}
                    requiredTimeSpendRatings={element.requiredTimeSpendRatings}
                    value={responsesForAck}
                    hasTimeSpendField={element.hasTimeSpendField}
                    observationComment={element.observationComment}
                    timeSpendFieldPrompt={element.timeSpendFieldPrompt}
                    disableOitComment={element.disableOitComment}
                    scale={props.report.settings ? props.report.settings.scale : props.departmentSettings.scale}
                    useNoNr={element.useNoNr}
                    useNotObserved={element.useNotObserved}
                    useNotResponsive={element.useNotResponsive}
                    author={props.report.getFullNameFor('author')}
                    onValueChange={(key, valueObject) =>
                      this.onUpdateComment(valueObject, element.id)
                    }
                  /> : <RatingMultiElement
                    key={index.toString()}
                    ratingPrompt={element.ratingPrompt}
                    notObservedPrompt={element.notObservedPrompt}
                    notResponsivePrompt={element.notResponsivePrompt}
                    defaultComments={element.defaultComments}
                    rating={responsesForAck.rating}
                    notObserved={responsesForAck.notObserved}
                    notResponsive={responsesForAck.notResponsive}
                    timeSpend={element.timeSpend}
                    comment={responsesForAck.comment}
                    observationComment={element.observationComment}
                    timeSpendFieldPrompt={element.timeSpendFieldPrompt}
                    author={props.report.getFullNameFor('author')}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                    scale={props.report.settings ? props.report.settings.scale : props.departmentSettings.scale}
                    // useNoNr={element.useNoNr}
                    useNoNr={responsesForAck.notResponsive || responsesForAck.notObserved}
                  />;
              case 'evaluation-rating':
                let trainerEvaluationResponse = this.state.responsesAck[element.id] || {
                  rating: 0,
                  notObserved: false,
                  notResponsive: false,
                  comment: ''
                };

                return props.report.getCanAcknowledge(props.userContext.scope) ?
                  <div className="dynamic-report-item-edit evaluation-rating-ack-edit" key={index.toString()}>
                    <div className="label" style={{whiteSpace: 'pre-wrap'}}>{element.ratingPrompt}</div>
                    <div className="evaluation-rating-panels">
                      <EvaluationPanel
                        title={`${props.report.getFullNameFor('author')} Self-Assessment`}
                        value={element}
                        notObservedPrompt={element.notObservedPrompt}
                        notResponsivePrompt={element.notResponsivePrompt}
                        scoreOverrides={element.scoreOverrides}
                        scale={element.scale || 3}
                      />
                      <div className="evaluation-rating-panel">
                        <EvaluationRatingResponse
                          name={element.id}
                          onValueChange={(key, valueObject) =>
                            this.onUpdateComment(valueObject, element.id)
                          }
                          ratingPrompt=""
                          showPrompt={false}
                          notObservedPrompt={element.notObservedPrompt}
                          notResponsivePrompt={element.notResponsivePrompt}
                          defaultComments={element.defaultComments}
                          requiredComments={element.requiredComments}
                          scoreOverrides={element.scoreOverrides}
                          scale={element.scale || 3}
                          value={trainerEvaluationResponse}
                          useNoNr={element.useNoNr}
                          useNotObserved={element.useNotObserved}
                          useNotResponsive={element.useNotResponsive}
                          heading="Trainer Assessment"
                          commentPlaceholder="Trainer notes"
                        />
                      </div>
                    </div>
                  </div> :
                  <EvaluationRatingElement
                    key={index.toString()}
                    ratingPrompt={element.ratingPrompt}
                    traineeValue={element}
                    trainerValue={trainerEvaluationResponse}
                    notObservedPrompt={element.notObservedPrompt}
                    notResponsivePrompt={element.notResponsivePrompt}
                    scoreOverrides={element.scoreOverrides}
                    scale={element.scale || 3}
                    author={props.report.getFullNameFor('author')}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                  />;
              case 'rating-simple':
                return (
                  <AckResponse
                    key={index.toString()}
                    comment={this.state.responsesAck[element.id]}
                    onChangeComment={(comment) => this.onUpdateComment(comment, element.id)}
                    canAck={props.report.getCanAcknowledge(props.userContext.scope)}
                    acknowledger={props.report.getFullNameFor('acknowledger')}
                    requireAckResponse={element.requireAckResponse}>
                    <RatingSimpleElement
                      ratingPrompt={element.ratingPrompt}
                      acceptablePrompt={element.acceptable}
                      unAcceptablePrompt={element.unAcceptable}
                      useNoNr={element.useNoNr}
                      notObservedPrompt={element.notObservedPrompt}
                      notResponsivePrompt={element.notResponsivePrompt}
                      rating={element.rating}
                      comment={element.comment}
                      timeSpendFieldPrompt={element.timeSpendFieldPrompt}
                      timeSpend={element.timeSpend}
                    />
                  </AckResponse>
                );
              case 'remedial-training':
                return (
                  <RemedialTrainingResponse
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'call-tracking':
                return (
                  <CallTrackingResponse
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'daily-patrol-log':
                return (
                  <DailyPatrolLogResponse
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'log-field':
                return (
                  <LogFieldResponse
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'question-field':
                return (
                  <QuestionFieldResponse
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'time-field':
                return (
                  <TimeTrackingField
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              case 'pble':
                return (
                  <PbleField
                    key={index.toString()}
                    element={element}
                    value={element}
                    isEdit={false}
                  />
                )
              default:
                throw new Error('Invalid element schema');
            }
          })}
        </div>

        {props.children}

        {props.view.signedAt &&
          <SignatureElement
            authoredBy={`${props.report.author.firstName} ${props.report.author.lastName}`}
            signedAt={props.view.signedAt}
          />
        }
        {props.report.getTypeHasAcknowledgement() && props.report.getCanAcknowledge(props.userContext.scope) && !this.isValid && (
          <div className="form" style={{color: 'red'}}>You have to fill in all the comments before you can acknowledge this report</div>
        )}
        {props.report.getTypeHasAcknowledgement() && this.isValid &&
          <ReportAcknowledgement
            report={props.report}
            requriedAckResponsesFilled={this.canAck}
            canSkip={this.canSkipAck}
            responsesAck={this.state.responsesAck}/>
        }
        {props.report.getTypeHasApproval() &&
          <ReportApproval report={props.report}/>
        }
        {props.report.getTypeHasApproveTwo() &&
          <ReportReview report={props.report}/>
        }
        {props.report.getTypeHasApproveThree() &&
          <ReportApproveThree report={props.report}/>
        }
        {props.report.getTypeHasApproveFour() &&
          <ReportApproveFour report={props.report}/>
        }
        {props.report.getTypeHasApproveFive() &&
          <ReportApproveFive report={props.report}/>
        }
        {this.canReject && (
          <RejectFormForm reportGuid={props.report.guid}/>
        )}
        {this.canRecall && (
          <RecallFormForm reportGuid={props.report.guid}/>
        )}

        {isNotAssignedFtoSubmitter(props.phase, props.report) && (
          <div className="submitted-by-not-assigned">
            <i className="fa fa-warning"/>
            <span>
            This report is submitted by
            <b> {props.report.author.firstName} </b>
            <b> {props.report.author.lastName} </b>
            but this phase is assigned to
            <b> {props.phase.fto.firstName} </b>
            <b> {props.phase.fto.lastName} </b>
          </span>
          </div>
        )}

      </Fragment>
    );
  };


}


// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    acknowledgeReportUpdate(formData) {
      return dispatch(trainingPhasesActionCreators.acknowledgeReportUpdate(formData));
    }
  }
}

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
    departmentSettings: state.departmentSettings.settings,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicReport);
